module.exports = __webpack_public_path__ + "img/bth_bed2_right_beibu_sel.6d1787ed.png";